(function(){function Tt(t){const e=new Set,r=o=>{e.has(o)||(e.add(o),console.warn(`[i18n] Missing translation for key: ${o}`))},n=t;return{t(o){const c=n[o];if(typeof c=="string")return c;const i=String(o);return r(i),i},has(o){return Object.prototype.hasOwnProperty.call(n,o)&&typeof n[o]=="string"},raw(){return t}}}var Et=new Map;function Pt(t,e){var r;const n=e.routinePreference;if(!t.showWhenRoutineIs.includes(n))return{render:!1};if(t.sectionKind==="stack"){var o;if(n==="formula")return{render:!1};const s=(o=e.result.foundations)!==null&&o!==void 0?o:[],l=n==="biohacker"?Math.min(t.maxItems,5):Math.min(t.maxItems,3),d=s.slice(0,l);return d.length===0?{render:!1}:{render:!0,items:d,routine:n}}const c=(r=e.result.sports)!==null&&r!==void 0?r:[],i=Math.min(t.maxItems,3),a=c.slice(0,i);return a.length===0?{render:!1}:{render:!0,items:a,routine:n}}function ot(t,e){Et.set(t,e)}var lt="youngle:quiz-result",At="youngle:add-to-cart",dt="youngle:add-to-cart-result",It=1e4,ut=0,Lt=class extends Error{constructor(t){super(t),this.name="AddToCartTimeoutError"}};function Mt(t){const e=n=>{t(n.detail)};document.addEventListener(lt,e);const r=window.YoungleQuizResult;return r!==void 0&&t(r),()=>{document.removeEventListener(lt,e)}}function Rt(t,e=It){const r=Nt();return new Promise((n,o)=>{let c=!1,i=null;const a=()=>{c=!0,document.removeEventListener(dt,s),i!==null&&(clearTimeout(i),i=null)},s=d=>{var u;const m=d.detail;if(m.requestId===r&&!c){if(a(),m.ok){var p,w;n({requestedLineCount:(p=m.requestedLineCount)!==null&&p!==void 0?p:0,successfulLineCount:(w=m.successfulLineCount)!==null&&w!==void 0?w:0});return}o(new Error((u=m.error)!==null&&u!==void 0?u:"Add-to-cart request failed"))}};document.addEventListener(dt,s),i=setTimeout(()=>{c||(a(),o(new Lt(`Add-to-cart request "${t.source}" did not settle within ${e}ms`)))},e);const l={...t,requestId:r};document.dispatchEvent(new CustomEvent(At,{detail:l}))})}function Nt(){return ut+=1,`yqr-shim-${Date.now()}-${ut}`}function X(t){return{raw:t}}var at="data-html-placeholder";function pt(t){return t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function Bt(t){return typeof t=="object"&&t!==null&&"raw"in t&&typeof t.raw=="string"}function Dt(t){if(t==null||t===!1)return"";if(t===!0)return"true";if(typeof t=="string")return pt(t);if(typeof t=="number")return pt(String(t));if(Bt(t))return t.raw;if(t instanceof Node)return t;if(Array.isArray(t)){if(t.every(e=>e instanceof Node)){const e=document.createDocumentFragment();for(const r of t)e.appendChild(r);return e}throw new TypeError("html: arrays of non-Node values are not supported")}throw typeof t=="function"?new TypeError("html: functions are not supported as interpolated values"):new TypeError(`html: unsupported interpolated value of type ${typeof t}`)}function f(t,...e){const r=new Map;let n="";for(let a=0;a<t.length;a++){var o;if(n+=(o=t[a])!==null&&o!==void 0?o:"",a<e.length){const s=Dt(e[a]);typeof s=="string"?n+=s:(r.set(a,s),n+=`<template ${at}="${a}"></template>`)}}const c=document.createElement("template");c.innerHTML=n;const i=c.content;return i.querySelectorAll(`template[${at}]`).forEach(a=>{const s=a.getAttribute(at);if(s===null)return;const l=Number(s),d=r.get(l);d!==void 0&&a.replaceWith(d)}),i}function x(t,e=document){return e.querySelector(t)}function Q(t,e,r,n){const o=r;return t.addEventListener(e,o,n),()=>t.removeEventListener(e,o,n)}function Ft(t,e){let r=null,n=null;const o=()=>{r=null;const i=n;n=null,i&&t(...i)},c=((...i)=>{n=i,r!==null&&clearTimeout(r),r=setTimeout(o,e)});return c.cancel=()=>{r!==null&&(clearTimeout(r),r=null),n=null},c.flush=()=>{r!==null&&(clearTimeout(r),o())},c}var mt=class extends Error{constructor(t,e){super(t),this.name="CartError",this.status=e}},Ot=150,zt="youngle:cart:changed",Ht={},Wt=Ot,it,Ut=new Set,ct=null;function jt(){var t;if(it!==void 0&&it.length>0)return it;const e=typeof window!="undefined"?(t=window.Shopify)===null||t===void 0||(t=t.routes)===null||t===void 0?void 0:t.root:void 0;return e!==void 0&&e.length>0?e:"/"}function ft(t){const e=jt();return`${e.endsWith("/")?e:`${e}/`}${t.startsWith("/")?t.slice(1):t}`}async function yt(t,e){if(!t.ok)throw new mt(`Cart request to ${e} failed with status ${t.status}`,t.status);return await t.json()}function Yt(){return ct||(ct=Ft(()=>{for(const e of Ut)e()},Wt)),ct}async function Qt(t){var e;const r={id:t.id,quantity:(e=t.quantity)!==null&&e!==void 0?e:1};return t.selling_plan!==void 0&&(r.selling_plan=t.selling_plan),t.properties!==void 0&&(r.properties=t.properties),yt(await fetch(ft("/cart/add.js"),{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(r)}),"/cart/add.js")}async function Vt(t){const e=[];if(t.length===0)return e;let r=!1;for(let n=0;n<t.length;n++){const o=t[n];try{const c=await Qt(o);r=!0,e.push({ok:!0,index:n,result:c})}catch(c){if(c instanceof mt)e.push({ok:!1,index:n,error:c});else throw c}}return r&&Gt(),e}async function Kt(){return yt(await fetch(ft("/cart.js"),{method:"GET",credentials:"same-origin",headers:{Accept:"application/json"}}),"/cart.js")}function Gt(){Yt()(),typeof document!="undefined"&&document.dispatchEvent(new CustomEvent(zt,{detail:{sender:Ht}}))}function ht(t,e){var r;if(typeof window=="undefined")return;const n=(r=window.Shopify)===null||r===void 0?void 0:r.analytics;if(!(n===void 0||typeof n.publish!="function"))try{n.publish(t,e)}catch{}}var Jt="gid://shopify/Product/";function Z(t){return t.startsWith(Jt)?t.slice(22):t}function Xt(t){return`yqr-product-${Z(t)}`}var Zt="youngle_promo",Ye=15;function te(t){const e=.85*(1-t/100);return Math.floor((1-e)*100)}function tt(t,e){return t.replace(/\{\{\s*percent\s*\}\}/g,String(e))}function ee(){try{return window.sessionStorage.getItem(Zt)}catch{return null}}function st(){var t,e,r,n,o,c,i;if(typeof window=="undefined")return null;const a=(t=window.theme)===null||t===void 0?void 0:t.promo;if(a===void 0||typeof a.key!="string"||a.key.length===0)return null;const s=(e=a.discountPercent)!==null&&e!==void 0?e:0;if(s<=0||a.sitewide!==!0&&ee()!==a.key)return null;const l=(r=a.strings)!==null&&r!==void 0?r:{},d=(n=a.subscriptionDisplayPercent)!==null&&n!==void 0?n:0;return{discountPercent:s,subscriptionDisplayPercent:d>0?d:te(s),strings:{saveBadge:(o=l.saveBadge)!==null&&o!==void 0?o:"",subscriptionTodayHtml:(c=l.subscriptionTodayHtml)!==null&&c!==void 0?c:"",subscriptionFuture:(i=l.subscriptionFuture)!==null&&i!==void 0?i:""}}}function _t(t,e){return t-Math.floor(t*e.discountPercent/100)}function re(t,e,r){return r===null||t<=0?{priceCents:t,compareCents:e,promoApplied:!1}:{priceCents:_t(t,r),compareCents:Math.max(e,t),promoApplied:!0}}var C="data-yqr-atc-confirm",gt="yqr-atc-confirm-styles",ne=class extends Error{constructor(){super("User dismissed the confirmation modal"),this.name="AtcConfirmCancelledError"}},et=null;function oe(){if(document.getElementById(gt))return;const t=document.createElement("style");t.id=gt,t.textContent=ue,document.head.appendChild(t)}function ae(){if(et&&et.isConnected)return et;const t=document.createElement("dialog");return t.setAttribute(C,""),document.body.appendChild(t),et=t,t}async function ie(t){try{const e=await Kt();for(const r of e.items){const n=r.selling_plan_allocation;if(r.variant_id===t&&n!==null&&n!==void 0)return!0}return!1}catch{return!1}}function ce(t){if(!t.includes("&"))return t;const e=document.createElement("textarea");return e.innerHTML=t,e.value}function P(t,e,r){var n;return ce((n=t[e])!==null&&n!==void 0?n:r)}function rt(t){var e;const r=document.createElement("template");return r.innerHTML=t,(e=r.content.textContent)!==null&&e!==void 0?e:""}function se(t){const e=/^(.+?[.!?])\s+(\S.*)$/s.exec(t.trim());return e===null?{first:t.trim(),rest:""}:{first:e[1],rest:e[2].trim()}}function le(t){const e=t.strings,r=se(rt(tt(e.subscriptionFuture,15)));return{onetimeBadge:rt(tt(e.saveBadge,t.discountPercent)),subscribeBadge:rt(tt(e.saveBadge,t.subscriptionDisplayPercent)),subscriptionToday:rt(tt(e.subscriptionTodayHtml,t.subscriptionDisplayPercent)),subscriptionFuture:r.first,subscriptionTerms:r.rest}}function vt(t){return t.length>0?f`<span class="yqr-atc-confirm__badge yqr-atc-confirm__badge--promo">${t}</span>`:f``}function de(t,e,r,n){var o,c,i,a,s,l,d;const u=n===null?null:le(n),m=t.sellingPlans,p=m[0],w=P(r,"atc_confirm_subscribe_label","Subscribe and save"),v=P(r,"atc_confirm_onetime_label","One-time purchase"),h=P(r,"atc_confirm_cta","Add to cart"),q=(K=>t.price>0?Math.round((1-K/t.price)*100):0)(p.price),S=w,_=p.price<t.price,H=_?X("checked"):"",W=_?"":X("checked"),R=t.title;P(r,"atc_confirm_quantity","Quantity");const U=P(r,"atc_confirm_supply_label","One month supply"),A=P(r,"atc_confirm_guarantee","30-day money-back guarantee"),L=P(r,"atc_confirm_subscribe_benefits","Cancel anytime"),N=P(r,"atc_confirm_subscribe_savings_for_life","Save {percent}% for life"),B=q>0?N.replace("{percent}",String(q)):"",I=n!==null&&u!==null&&u.subscriptionToday.length>0&&u.subscriptionFuture.length>0,D=I?"":B,k=`${I&&u.subscriptionTerms.length>0?u.subscriptionTerms:L} · ${A}`,T=/^(.*?)([.!?]?)$/s.exec((o=u==null?void 0:u.subscriptionFuture)!==null&&o!==void 0?o:""),F={body:(c=T==null?void 0:T[1])!==null&&c!==void 0?c:"",punctuation:(i=T==null?void 0:T[2])!==null&&i!==void 0?i:""},j=I?f`<span class="yqr-atc-confirm__promo-breakdown" data-yqr-promo-breakdown>
        <span class="yqr-atc-confirm__promo-line yqr-atc-confirm__promo-line--today">
          <span class="yqr-atc-confirm__promo-text">${u.subscriptionToday}</span>
        </span>
        <span class="yqr-atc-confirm__promo-line">
          <span class="yqr-atc-confirm__promo-text"
            >${F.body} (<span data-yqr-promo-renewal-price
              >${e(p.price)}</span
            >)${F.punctuation}</span
          >
        </span>
      </span>`:f``,O=vt((a=u==null?void 0:u.onetimeBadge)!==null&&a!==void 0?a:""),y=vt((s=u==null?void 0:u.subscribeBadge)!==null&&s!==void 0?s:""),g=P(r,"atc_confirm_recommended","Recommended"),$=m.length>1?f`<select
          class="yqr-atc-confirm__plan-select"
          data-yqr-plan-select
        >
          ${X(m.map(K=>`<option value="${K.id}" data-plan-price="${K.price}" data-plan-name="${K.name.replace(/"/g,"&quot;")}">${K.name}</option>`).join(""))}
        </select>`:f`<span class="yqr-atc-confirm__plan-name yg-mono-unit--muted"
          >${p.name}</span
        >`,E=((l=u==null?void 0:u.subscribeBadge)!==null&&l!==void 0?l:"").length>0,z=_&&!E?f`<span class="yqr-atc-confirm__badge">${g}</span>`:f``,V=_?f`<span class="yqr-atc-confirm__compare-price">${e(t.price)}</span>`:f``,Y=(d=t.imageUrl)!==null&&d!==void 0?d:"",J=Y.length>0?f`<div class="yqr-atc-confirm__image-col">
        <img
          class="yqr-atc-confirm__image"
          src="${Y}"
          alt="${R}"
          loading="eager"
        />
      </div>`:f``;return f`
    <div class="yqr-atc-confirm__body${X(Y.length>0?" yqr-atc-confirm__body--has-image":"")}">
      ${J}
      <div class="yqr-atc-confirm__content-col">
      <div class="yqr-atc-confirm__header">
        <h3 class="yqr-atc-confirm__title">${R}</h3>
        <button
          type="button"
          class="yqr-atc-confirm__close"
          data-yqr-confirm-close
          aria-label="Close"
        >\u00d7</button>
      </div>

      <fieldset class="yqr-atc-confirm__options">
        <label class="yg-card yqr-atc-confirm__option">
          <input
            type="radio"
            name="yqr-atc-plan"
            value="onetime"
            data-yqr-plan-choice="onetime"
            ${W}
          />
          <span class="yqr-atc-confirm__option-content">
            <span class="yqr-atc-confirm__option-header">
              <span class="yqr-atc-confirm__option-label">${v}</span>
              ${O}
            </span>
            <span class="yqr-atc-confirm__price-row">
              <span class="yg-display-num--sm"
                >${e(t.price)}</span
              >
            </span>
          </span>
        </label>

        <label class="yg-card yqr-atc-confirm__option">
          <input
            type="radio"
            name="yqr-atc-plan"
            value="subscribe"
            data-yqr-plan-choice="subscribe"
            ${H}
          />
          <span class="yqr-atc-confirm__option-content">
            <span class="yqr-atc-confirm__option-header">
              <span class="yqr-atc-confirm__option-label" data-yqr-subscribe-label
                >${S}</span
              >
              ${z}
              ${y}
            </span>
            <span class="yqr-atc-confirm__savings-for-life" data-yqr-savings-for-life
              >${D}</span
            >
            ${$}
            <span class="yqr-atc-confirm__price-row" data-yqr-subscribe-price>
              <span class="yg-display-num--sm"
                >${e(p.price)}</span
              >
              ${V}
            </span>
            ${j}
            <span class="yqr-atc-confirm__benefits">${k}</span>
          </span>
        </label>
      </fieldset>

      <p class="yg-mono-unit--muted yqr-atc-confirm__variant">
        ${t.variantTitle} · ${U}
      </p>

      <div class="yqr-atc-confirm__cta-row">
        <div class="yqr-atc-confirm__stepper" data-yqr-quantity-row>
          <button type="button" class="yqr-atc-confirm__stepper-btn" data-yqr-qty-minus aria-label="Decrease">\u2212</button>
          <input type="number" class="yqr-atc-confirm__stepper-input" data-yqr-qty-input value="1" min="1" max="9" />
          <button type="button" class="yqr-atc-confirm__stepper-btn" data-yqr-qty-plus aria-label="Increase">+</button>
        </div>
        <button
          type="button"
          class="yg-btn yg-btn--red yqr-atc-confirm__cta"
          data-yqr-confirm-cta
        >
          ${h}
        </button>
      </div>
      </div>
    </div>
  `}function wt(t,e,r,n={}){return async o=>{if(o.items.length!==1)return t(o);const c=o.items[0],i=e.lookupByVariant(c.variantId);if(!i||i.sellingPlans.length===0||await ie(c.variantId))return t(o);oe();const a=ae();a.classList.remove("yqr-atc-confirm--many-items");const s=i.sellingPlans,l=st();a.innerHTML="",a.appendChild(de(i,r,n,l));const d=i;return new Promise((u,m)=>{let p=!1;const w=a.querySelector("[data-yqr-confirm-cta]"),v=a.querySelector("[data-yqr-plan-select]"),h=a.querySelector("[data-yqr-subscribe-price]"),b=a.querySelector(".yqr-atc-confirm__option:first-child .yqr-atc-confirm__price-row"),q=a.querySelector("[data-yqr-savings-for-life]"),S=a.querySelector("[data-yqr-promo-renewal-price]"),_=a.querySelector("[data-yqr-qty-input]"),H=a.querySelector("[data-yqr-qty-minus]"),W=a.querySelector("[data-yqr-qty-plus]");function R(y,g,$){if(!y)return;const E=l===null?g:_t(g,l),z=E*$,V=l===null?"yg-display-num--sm":"yg-display-num--sm yqr-atc-confirm__price--promo",Y=$>1?` <span class="yqr-atc-confirm__unit-price">(${$} × ${r(E)})</span>`:"",J=E<d.price?` <span class="yqr-atc-confirm__compare-price">${r(d.price*$)}</span>`:"";y.innerHTML=`<span class="${V}">${r(z)}</span>`+Y+J}function U(){if(v){const y=v.selectedOptions[0];if(y)return Number(y.dataset.planPrice)}return s[0].price}function A(){return _?Math.max(1,Math.min(9,Number(_.value)||1)):1}function L(){const y=A(),g=U();R(h,g,y),R(b,d.price,y),S&&(S.textContent=r(g*y))}function N(y){_&&(_.value=String(Math.max(1,Math.min(9,Math.round(y)))),L())}const B=H?Q(H,"click",()=>N(A()-1)):null,I=W?Q(W,"click",()=>N(A()+1)):null,D=_?Q(_,"change",()=>N(A())):null,k=v?Q(v,"change",()=>{const y=v.selectedOptions[0];if(!y)return;const g=Number(y.dataset.planPrice),$=d.price>0?Math.round((1-g/d.price)*100):0;L();const E=a.querySelector("[data-yqr-promo-breakdown]")!==null;if(q&&!E){const z=P(n,"atc_confirm_subscribe_savings_for_life","Save {percent}% for life");q.textContent=$>0?z.replace("{percent}",String($)):""}}):null,T=a.querySelectorAll('input[name="yqr-atc-plan"]'),F=[];for(const y of T)F.push(Q(y,"change",L));const j=a.querySelector("[data-yqr-confirm-close]");j&&j.addEventListener("click",()=>{a.close()},{once:!0});const O=Q(a,"click",y=>{y.target===a&&a.close()});w&&w.addEventListener("click",()=>{p=!0,a.close()},{once:!0}),a.addEventListener("close",()=>{O(),k&&k(),B&&B(),I&&I(),D&&D();for(const J of F)J();if(!p){m(new ne);return}const y=a.querySelector('input[name="yqr-atc-plan"]:checked'),g=(y==null?void 0:y.value)==="subscribe";let $=s[0].id;v&&($=Number(v.value));const E=A(),z=e.lookupByHandle(d.handle),V=z&&Number(Z(z.shopifyId))||c.variantId;g?ht("youngle_quiz:atc_confirm_subscribe",{product_id:V,selling_plan_id:$,quantity:E}):ht("youngle_quiz:atc_confirm_onetime",{product_id:V,quantity:E});const Y={variantId:c.variantId,quantity:E,...g?{sellingPlanId:$}:{}};t({source:o.source,items:[Y]}).then(u,m)},{once:!0}),l!==null&&L(),a.showModal()})}}var ue=`
[${C}] {
  border: 0;
  padding: 0;
  max-width: 480px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  background: var(--pure-white, #f8f8f8);
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-sans, sans-serif);
  /* Desktop: centered modal */
  margin: auto;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

@media (max-width: 719px) {
  [${C}] {
    /* Mobile: bottom-attached drawer */
    margin: auto auto 0 auto;
    inset: auto 0 0 0;
    border-radius: 0;
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.12);
  }
}

@media (max-width: 719px) and (max-height: 700px) {
  [${C}] {
    max-height: 100vh;
    max-height: 100dvh;
    height: 100%;
  }
  [${C}] .yqr-atc-confirm__body {
    min-height: 100%;
  }
  [${C}] .yqr-atc-confirm__content-col {
    flex: 1;
  }
  [${C}] .yqr-atc-confirm__cta-row {
    margin-top: auto;
  }
  [${C}]:has(.yqr-atc-confirm__bundle-list) .yqr-atc-confirm__plan-select,
  [${C}]:has(.yqr-atc-confirm__bundle-list) .yqr-atc-confirm__benefits {
    display: none;
  }
}

@media (max-width: 719px) {
  [${C}].yqr-atc-confirm--many-items {
    max-height: 100vh;
    max-height: 100dvh;
    height: 100%;
  }
}

[${C}]::backdrop {
  background: rgba(10, 10, 10, 0.45);
}

.yqr-atc-confirm__body {
  position: relative;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  animation: yqrAtcConfirmIn 220ms cubic-bezier(.2,.7,.2,1) both;
}

.yqr-atc-confirm__body::before {
  content: none;
}

.yqr-atc-confirm__image-col {
  display: none;
}

.yqr-atc-confirm__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.yqr-atc-confirm__content-col {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-24, 24px);
  padding: var(--space-24, 24px) var(--gutter-mobile, 20px) calc(var(--space-24, 24px) + env(safe-area-inset-bottom));
}

@media (min-width: 720px) {
  .yqr-atc-confirm__content-col {
    padding: var(--space-32, 32px);
  }

  [${C}]:has(.yqr-atc-confirm__body--has-image) {
    max-width: 520px;
  }

  .yqr-atc-confirm__body--has-image .yqr-atc-confirm__image-col {
    display: none;
  }
}

.yqr-atc-confirm__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: 1px solid var(--gray-20, #c8c8d0);
  border-radius: 50%;
  background: transparent;
  color: var(--cold-black, #0a0a0a);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 160ms ease, background 160ms ease;
}

.yqr-atc-confirm__close:hover,
.yqr-atc-confirm__close:focus-visible {
  border-color: var(--gray-50, #64647a);
  background: var(--gray-05, #f0f0f4);
}

.yqr-atc-confirm__title {
  margin: 0;
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-sans, sans-serif);
  font-weight: 500;
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.yqr-atc-confirm__options {
  border: 0;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__option {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  gap: var(--space-12, 12px);
  cursor: pointer;
  padding: var(--space-16, 16px);
  border-radius: 15px;
  transition: border-color 160ms cubic-bezier(.2,.7,.2,1);
}

.yqr-atc-confirm__option:has(input:checked) {
  border-color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__option input[type="radio"] {
  appearance: none;
  margin: 0;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border: 2px solid var(--cold-black, #0a0a0a);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  margin-top: 2px;
}

.yqr-atc-confirm__option input[type="radio"]:checked {
  border-color: var(--cold-black, #0a0a0a);
  background: var(--fire-red, #ff4b00);
  box-shadow: inset 0 0 0 3px var(--pure-white, #f8f8f8);
}

.yqr-atc-confirm__option-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__option-label {
  font-weight: 500;
}

.yqr-atc-confirm__plan-select {
  appearance: none;
  font-family: var(--font-mono, monospace);
  font-size: 13px;
  border: var(--hairline, 1px solid #e0e0e4);
  border-radius: var(--radius-sm, 4px);
  padding: var(--space-8, 8px) var(--space-32, 32px) var(--space-8, 8px) var(--space-12, 12px);
  background: var(--pure-white, #f8f8f8) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%230a0a0a'/%3E%3C/svg%3E") no-repeat right 12px center;
  color: var(--cold-black, #0a0a0a);
  width: 100%;
  max-width: 200px;
  cursor: pointer;
}

.yqr-atc-confirm__price-row {
  display: flex;
  align-items: baseline;
  gap: var(--space-8, 8px);
  flex-wrap: wrap;
}

.yqr-atc-confirm__plan-select + .yqr-atc-confirm__price-row,
.yqr-atc-confirm__plan-name + .yqr-atc-confirm__price-row {
  margin-top: var(--space-8, 8px);
}

.yqr-atc-confirm__variant {
  margin: 0;
}

.yqr-atc-confirm__cta-row {
  display: flex;
  align-items: stretch;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__stepper {
  display: inline-flex;
  align-items: center;
  border: var(--hairline, 1px solid #e0e0e4);
  border-radius: var(--radius-pill, 999px);
  overflow: hidden;
  flex-shrink: 0;
}

.yqr-atc-confirm__stepper-btn {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-mono, monospace);
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

[${C}] .yqr-atc-confirm__stepper-input {
  width: 40px;
  height: 36px;
  border: 0;
  border-left: var(--hairline, 1px solid #e0e0e4);
  border-right: var(--hairline, 1px solid #e0e0e4);
  background: transparent;
  text-align: center;
  font-family: var(--font-mono, monospace);
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
  padding: 0;
  margin: 0;
  line-height: 36px;
  -moz-appearance: textfield;
  appearance: textfield;
}

[${C}] .yqr-atc-confirm__stepper-input::-webkit-inner-spin-button,
[${C}] .yqr-atc-confirm__stepper-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.yqr-atc-confirm__unit-price {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

.yqr-atc-confirm__option-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__badge {
  font-family: var(--font-mono, monospace);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--fire-red, #ff4b00);
  color: var(--pure-white, #f8f8f8);
  padding: 2px 8px;
  border-radius: var(--radius-pill, 999px);
  white-space: nowrap;
}

.yqr-atc-confirm__savings-for-life {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  font-weight: 500;
  color: var(--fire-red, #ff4b00);
  padding-bottom: var(--space-4, 4px);
}

.yqr-atc-confirm__savings-for-life:empty {
  display: none;
}

.yqr-atc-confirm__price--promo {
  color: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__promo-breakdown {
  display: flex;
  flex-direction: column;
  gap: var(--space-4, 4px);
}

.yqr-atc-confirm__promo-line {
  display: flex;
  align-items: baseline;
  gap: var(--space-8, 8px);
  font-family: var(--font-sans, sans-serif);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__promo-line::before {
  content: '';
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--cold-black, #0a0a0a);
  transform: translateY(-1px);
}

.yqr-atc-confirm__promo-line--today::before {
  background: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__promo-text {
  flex: 1;
}

[data-yqr-promo-renewal-price] {
  white-space: nowrap;
}

.yqr-atc-confirm__compare-price {
  font-family: var(--font-mono, monospace);
  font-size: 13px;
  color: var(--gray-30, #9494a3);
  text-decoration: line-through;
}

.yqr-atc-confirm__benefits {
  font-family: var(--font-mono, monospace);
  font-size: 11px;
  color: var(--gray-50, #64647a);
  margin-top: var(--space-4, 4px);
}


.yqr-atc-confirm__cta {
  flex: 1;
}

.yqr-atc-confirm__bundle-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__bundle-item {
  display: flex;
  align-items: center;
  gap: var(--space-12, 12px);
  font-family: var(--font-sans, sans-serif);
  font-size: 14px;
  color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__bundle-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: var(--radius-sm, 4px);
  flex-shrink: 0;
}

.yqr-atc-confirm__bundle-item-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.yqr-atc-confirm__bundle-item-meta {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

.yqr-atc-confirm__savings-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.yqr-atc-confirm__savings-group .yqr-atc-confirm__savings-for-life {
  padding-bottom: 0;
}

.yqr-atc-confirm__bundle-bonus {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  font-weight: 500;
  color: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__then-recurring {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

@keyframes yqrAtcConfirmIn {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .yqr-atc-confirm__option {
    transition: none;
  }
  .yqr-atc-confirm__body {
    animation: none;
  }
}
`,bt="__youngleCascadeRegistry";function pe(){let t=window[bt];return t===void 0&&(t=new Map,window[bt]=t),t}function me(t,e){const r=pe();return r.set(t,e),()=>{r.delete(t)}}function fe(t,e,r,n){var o,c,i,a;const s=(o=t.matched_health_markers)!==null&&o!==void 0?o:[],l=s.length>0,d=l?r.why_this_summary_with_markers:r.why_this_summary_without_markers,u=e!=null?e:{},m=[];for(const q of s){const S=u[q],_=f`
      <li class="yqr-why__item">
        <strong class="yqr-why__marker">${q}</strong>
        ${ye(S,r)}
      </li>
    `.querySelector("li");_!==null&&m.push(_)}const p=m.length>0?f`<ul class="yqr-why__list" role="list">${m}</ul>`:null,w=(c=t.recommendation_reason)!==null&&c!==void 0?c:"",v=!l&&w.trim().length>0?f`<p class="yqr-why__reason">${w}</p>`:null,h=f`
    <details class="yqr-why">
      <summary class="yqr-why__summary">${d}</summary>
      <div class="yqr-why__body">
        ${p!=null?p:""}
        ${v!=null?v:""}
      </div>
    </details>
  `.querySelector("details");if(h===null)throw new Error("renderWhyThis: expected a details root in the template output");const b=(i=n==null||(a=n.analyticsProductId)===null||a===void 0?void 0:a.trim())!==null&&i!==void 0?i:"";return b.length>0&&h.setAttribute("data-yqr-product-id",b),h}function ye(t,e){if(t===void 0)return f`<p class="yqr-why__trace yqr-why__trace--missing"></p>`;const r=t.answer.trim(),n=t.question.trim();return r.length===0&&n.length===0?f`<p class="yqr-why__trace yqr-why__trace--missing"></p>`:f`<p class="yqr-why__trace">
    ${e.why_this_you_said_prefix}
    &quot;${r}&quot;
    ${e.why_this_when_asked_prefix}
    &quot;${n}&quot;
  </p>`}function he(t,e){const r=t.trim(),n=e.trim();return r.length===0&&n.length===0?"":r.length>0&&n.length>0?`${r} ${n}`:r||n}function qt(t,e){if(e.replaceChildren(),t.length!==0)for(const m of t){var r,n,o,c,i,a,s,l,d,u;const p=m.name.trim();if(p.length===0)continue;const w=he((r=(n=m.amount_text)===null||n===void 0?void 0:n.trim())!==null&&r!==void 0?r:"",(o=(c=m.unit)===null||c===void 0?void 0:c.trim())!==null&&o!==void 0?o:""),v=(i=(a=m.scientific_name)===null||a===void 0?void 0:a.trim())!==null&&i!==void 0?i:"",h=(s=(l=m.description)===null||l===void 0?void 0:l.trim())!==null&&s!==void 0?s:"",b=(d=(u=m.note)===null||u===void 0?void 0:u.trim())!==null&&d!==void 0?d:"";if(!(h.length>0||v.length>0||b.length>0)){const _=f`<div class="yqr-spotlight__ingredient yqr-spotlight__ingredient--static">
        <div class="yqr-spotlight__ingredient-row">
          <span class="yqr-spotlight__ingredient-name">${p}</span>
          ${w.length>0?f`<span class="yqr-spotlight__ingredient-amount">${w}</span>`:""}
        </div>
      </div>`;e.appendChild(_);continue}const q=[];if(v.length>0){const _=f`<p class="yqr-spotlight__ingredient-scientific">${v}</p>`;q.push(_)}if(h.length>0){const _=f`<p class="yqr-spotlight__ingredient-desc">${h}</p>`;q.push(_)}if(b.length>0){const _=f`<p class="yqr-spotlight__ingredient-note">${b}</p>`;q.push(_)}const S=f`<details class="yqr-spotlight__ingredient">
      <summary>
        <span class="yqr-spotlight__ingredient-name">${p}</span>
        ${w.length>0?f`<span class="yqr-spotlight__ingredient-amount">${w}</span>`:""}
        <span class="yqr-spotlight__ingredient-chevron" aria-hidden="true">&#x25BE;</span>
      </summary>
      <div class="yqr-spotlight__ingredient-body">
        ${q}
      </div>
    </details>`;e.appendChild(S)}}function _e(t,e){if(t.length===0||e.length===0)return t;const r=t.toLowerCase(),n=e.toLowerCase();if(!r.startsWith(n))return t;const o=t.slice(e.length).replace(/^[\s:·\-–—]+/,"");return o.length===0?t:o.charAt(0).toUpperCase()+o.slice(1)}function ge(t){let e=0;for(const r of t)(e===0||r.price<e)&&(e=r.price);return e}function xt(t,e,r,n,o){var c;const i=x("[data-yqr-row-card-price-from]",t),a=x("[data-yqr-row-card-price]",t),s=x("[data-yqr-row-card-compare]",t);if(i===null||a===null||s===null)return;const l=ge(e.sellingPlans),d=r.length>0&&l>0&&l<e.price,u=re(d?l:e.price,!d&&e.compareAtPrice>e.price?e.compareAtPrice:0,o);i.textContent=d?r:"",i.classList.toggle("yqr-row-card__price-from--hidden",!d),a.textContent=n(u.priceCents),a.classList.toggle("yqr-row-card__price--promo",u.promoApplied);const m=(c=s.closest(".yqr-row-card__compare"))!==null&&c!==void 0?c:s,p=u.compareCents>u.priceCents;s.textContent=p?n(u.compareCents):"",m.classList.toggle("yqr-row-card__compare--hidden",!p)}function ve(t,e,r){var n,o,c,i,a,s,l;const d=(n=t.editorial)!==null&&n!==void 0?n:null,u=d!==null&&d.card_blurb!==null?d.card_blurb.trim():"",m=_e(u.length>0?u:((o=t.recommendation_reason)!==null&&o!==void 0?o:"").trim(),t.title),p=f`<article
    class="yqr-row-card ${r.densityClass}"
    data-yqr-row-card
    data-shopify-product-id="${Z(t.shopify_id)}"
  >
    <div class="yqr-row-card__anchor" data-yqr-product-anchor aria-hidden="true"></div>
    <div class="yqr-row-card__media" data-yqr-row-card-media></div>
    <div class="yqr-row-card__body">
      <h3 class="yqr-row-card__title" data-yqr-row-card-title></h3>
      <p class="yqr-row-card__blurb yqr-row-card__blurb--hidden" data-yqr-row-card-blurb></p>
      <div class="yqr-row-card__why" data-yqr-row-card-why></div>
      <div class="yqr-row-card__price-row">
        <span class="yqr-row-card__price-from yqr-row-card__price-from--hidden" data-yqr-row-card-price-from></span>
        <span class="yqr-row-card__price" data-yqr-row-card-price></span>
        <s class="yqr-row-card__compare yqr-row-card__compare--hidden">
          <span data-yqr-row-card-compare></span>
        </s>
        <span class="yqr-row-card__supply-note yqr-row-card__supply-note--hidden" data-yqr-row-card-supply-note></span>
      </div>
      <div class="yqr-row-card__actions">
        <button type="button" class="button yqr-row-card__atc" data-yqr-row-card-atc></button>
        <button type="button" class="yqr-row-card__learn-more yqr-row-card__learn-more--hidden" data-yqr-row-card-learn-more></button>
      </div>
      <div class="yqr-row-card__sources" hidden aria-hidden="true">
        <div data-yqr-row-card-story></div>
        <div data-yqr-row-card-mechanism></div>
        <div data-yqr-row-card-ingredients></div>
      </div>
    </div>
  </article>`.querySelector("[data-yqr-row-card]");if(!(p instanceof HTMLElement))throw new TypeError("createCatalogRowCardElement: expected article root");const w=x("[data-yqr-product-anchor]",p),v=x("[data-yqr-row-card-media]",p),h=x("[data-yqr-row-card-title]",p),b=x("[data-yqr-row-card-blurb]",p),q=x("[data-yqr-row-card-why]",p),S=x("[data-yqr-row-card-supply-note]",p),_=x("[data-yqr-row-card-atc]",p);if(w===null||v===null||h===null||b===null||q===null||S===null||_===null)throw new TypeError("createCatalogRowCardElement: missing internal slot");if(w.id=Xt(t.shopify_id),h.textContent=t.title,m.length>0?(b.textContent=m,b.classList.remove("yqr-row-card__blurb--hidden")):(b.textContent="",b.classList.add("yqr-row-card__blurb--hidden")),q.replaceChildren(),r.showWhyThis){const k={editorial:d};t.matched_health_markers!==void 0&&(k.matched_health_markers=t.matched_health_markers),t.recommendation_reason!==void 0&&(k.recommendation_reason=t.recommendation_reason);const T=fe(k,r.healthMarkerSources,r.whyThisLabels,{analyticsProductId:Z(t.shopify_id)});q.appendChild(T)}xt(p,e,(c=r.priceFromLabel)!==null&&c!==void 0?c:"",r.formatPrice,st());const H=(i=r.supplyNoteLabel)!==null&&i!==void 0?i:"";H.length>0?(S.textContent=H,S.classList.remove("yqr-row-card__supply-note--hidden")):(S.textContent="",S.classList.add("yqr-row-card__supply-note--hidden")),v.replaceChildren();const W=(a=(s=t.image_url)===null||s===void 0?void 0:s.trim())!==null&&a!==void 0?a:"";if(W.length>0){const k=f`<img
      class="yqr-row-card__image"
      src="${W}"
      alt="${t.title}"
      loading="lazy"
      decoding="async"
    />`.querySelector("img");k!==null&&v.appendChild(k)}const R=(l=r.learnMoreLabel)!==null&&l!==void 0?l:"",U=x("[data-yqr-row-card-learn-more]",p),A=x("[data-yqr-row-card-story]",p),L=x("[data-yqr-row-card-mechanism]",p),N=x("[data-yqr-row-card-ingredients]",p);if(U!==null&&R.length>0){var B,I;const k=d!==null&&d.story!==null&&d.story.trim().length>0,T=((B=t.description)!==null&&B!==void 0?B:"").trim().length>0,F=d!==null&&d.mechanism!==null&&d.mechanism.trim().length>0,j=((I=t.ingredients)!==null&&I!==void 0?I:[]).length>0;if(k||T||F||j){if(U.textContent=R,U.classList.remove("yqr-row-card__learn-more--hidden"),A!==null){var D;const O=k?d.story.trim():((D=t.description)!==null&&D!==void 0?D:"").trim();if(O.length>0)for(const y of O.split(/\n\s*\n/).filter(g=>g.trim().length>0)){const g=document.createElement("p");g.className="yqr-row-card__story-p",g.textContent=y.trim(),A.appendChild(g)}}if(L!==null&&F){const O=d.mechanism.trim();for(const y of O.split(/\n\s*\n/).filter(g=>g.trim().length>0)){const g=document.createElement("p");g.className="yqr-row-card__mechanism-p",g.textContent=y.trim(),L.appendChild(g)}}N!==null&&j&&qt(t.ingredients,N)}}return p}function we(t,e,r,n,o,c){const i=x("[data-yqr-row-card-atc]",t);if(i===null)return;i.textContent=e.available?o:c,i.disabled=!e.available,i.setAttribute("data-variant-id",String(e.variantId));const a=e.variantId,s=i.cloneNode(!0);i.replaceWith(s),s.addEventListener("click",()=>{e.available&&s.getAttribute("data-yqr-added")!=="true"&&n({source:r,items:[{variantId:a,quantity:1}]}).catch(l=>{const d=l instanceof Error?l.message:String(l);console.warn("[YQR-row-card]","Add to cart failed",d)})})}var nt=class extends Error{constructor(t){super(t),this.name="ProductRowConfigError"}},be=new Set(["quiz_foundations","quiz_sports","manual"]),qe=new Set(["comfortable","compact"]);function Ct(t,e){const r=t.getAttribute(e);if(r===null)throw new nt(`Product row root is missing required attribute: ${e}`);return r}function G(t,e,r){const n=t.getAttribute(e);return n==="true"?!0:n==="false"?!1:r}function xe(t,e,r,n,o){const c=t.getAttribute(e);if(c===null||c.trim().length===0)return o;const i=Number.parseInt(c,10);return Number.isNaN(i)?o:Math.min(n,Math.max(r,i))}function Ce(t){var e,r;const n=Ct(t,"data-section-id"),o=Ct(t,"data-source");if(!be.has(o))throw new nt(`Product row has unknown data-source: ${o}`);const c=o,i=xe(t,"data-max-items",1,6,3),a=(e=t.getAttribute("data-card-density"))!==null&&e!==void 0?e:"comfortable";if(!qe.has(a))throw new nt(`Product row has unknown data-card-density: ${a}`);const s=a,l=G(t,"data-show-why-this",!0),d=(r=t.getAttribute("data-heading-template"))!==null&&r!==void 0?r:"",u=[];return G(t,"data-show-formula",!1)&&u.push("formula"),G(t,"data-show-stack",!0)&&u.push("stack"),G(t,"data-show-biohacker",!0)&&u.push("biohacker"),G(t,"data-show-unknown",!0)&&u.push("unknown"),{root:t,sectionId:n,dataSource:c,maxItems:i,cardDensity:s,showWhyThis:l,headingTemplate:d,showWhenRoutineIs:u}}function Se(){var t;if(typeof window!="undefined")return(t=window.Shopify)===null||t===void 0?void 0:t.money_format}function ke(){var t;if(typeof document=="undefined")return"en";const e=(t=document.documentElement.lang)===null||t===void 0?void 0:t.trim();return e!==void 0&&e.length>0?e:"en"}function $e(t){var e;if(typeof window=="undefined")return t;const r=(e=window.Shopify)===null||e===void 0||(e=e.currency)===null||e===void 0?void 0:e.active;return r!==void 0&&r.length>0?r:t}function Te(){if(typeof window!="undefined"){const e=window.cart;if(e!==void 0&&typeof e.getCart=="function"){e.getCart();return}}if(typeof document=="undefined")return;const t=document.querySelector("[data-cart-drawer-toggle]");if(t!==null){t.click();return}document.dispatchEvent(new CustomEvent("cart:open"))}function Ee(t,e){const r=t/100,n=Pe(r,e);return n!==null?n:Ae(r,e.fallbackFormat)}function Pe(t,e){try{return typeof Intl=="undefined"||typeof Intl.NumberFormat!="function"?null:new Intl.NumberFormat(e.locale,{style:"currency",currency:e.currency}).format(t)}catch{return null}}function Ae(t,e){const r=t.toFixed(2).replace(".",","),n=t.toFixed(2),o=Math.round(t).toString(),c=n.replace("."," ");return e===void 0?n:e.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,r).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,o).replace(/\{\{\s*amount_with_space_separator\s*\}\}/g,c).replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g,o).replace(/\{\{\s*amount_no_decimals\s*\}\}/g,o).replace(/\{\{\s*amount\s*\}\}/g,n)}async function Ie(t,e,r){const n=`${t}/product-editorial`,o=await fetch(n,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({shopify_ids:e.map(String),locale:r})});return o.ok?(await o.json()).products:(console.warn("[product-row]","Editorial API returned",o.status,o.statusText),[])}function Le(t){return{variantId:t.variantId,variantTitle:"",price:t.price,compareAtPrice:t.compareAtPrice,handle:t.handle,title:t.title,url:`/products/${t.handle}`,available:t.available,imageUrl:t.imageUrl,ingredients:"",usage:"",sellingPlans:t.sellingPlans.map(e=>({id:e.id,name:e.name,price:e.price,compareAtPrice:e.compareAtPrice}))}}function Me(t,e){return{lookup(r){return(typeof r=="string"?Number(r.replace(/\D/g,"")):r)===t.shopifyId?e:null},lookupByHandle(r){return r===t.handle?{shopifyId:`gid://shopify/Product/${t.shopifyId}`,info:e}:null},lookupByVariant(r){return r===t.variantId?e:null},get size(){return 1}}}async function Re(t){const e=t.items;if(e.length===0)return{requestedLineCount:0,successfulLineCount:0};const r=(await Vt(e.map(n=>{var o;return{id:n.variantId,quantity:(o=n.quantity)!==null&&o!==void 0?o:1,...n.sellingPlanId!==void 0?{selling_plan:n.sellingPlanId}:{}}}))).filter(n=>n.ok).length;return r>0&&Te(),{requestedLineCount:e.length,successfulLineCount:r}}function St(){const t=$e("EUR"),e=Se(),r=ke(),n=e!==void 0?{locale:r,currency:t,fallbackFormat:e}:{locale:r,currency:t};return o=>Ee(o,n)}function Ne(t){const e=t.querySelectorAll("[data-yqr-row-card]"),r=St();for(const n of e){const o=n.querySelector("[data-yqr-row-card-atc]");if(o===null||o.disabled)continue;const c=n.getAttribute("data-product-info");if(c===null||c.trim().length===0)continue;let i;try{i=JSON.parse(c)}catch{console.warn("[product-row]","Invalid data-product-info JSON on card");continue}const a=Le(i),s=wt(Re,Me(i,a),r);o.addEventListener("click",()=>{o.disabled||o.getAttribute("data-yqr-added")!=="true"&&s({source:"product-row",items:[{variantId:i.variantId,quantity:1}]}).catch(l=>{if(l instanceof Error&&l.name==="AtcConfirmCancelledError")return;const d=l instanceof Error?l.message:String(l);console.warn("[product-row]","Add to cart failed",d)})})}}function Be(t){var e;const r=st();if(r===null)return;const n=St(),o=(e=t.getAttribute("data-price-from-label"))!==null&&e!==void 0?e:"";for(const c of t.querySelectorAll("[data-yqr-row-card]")){const i=c.getAttribute("data-product-info");if(i===null||i.trim().length===0)continue;let a;try{a=JSON.parse(i)}catch{continue}xt(c,a,o,n,r)}}async function De(t){var e;const r=t.getAttribute("data-api-base"),n=(e=t.getAttribute("data-locale"))!==null&&e!==void 0?e:"de";if(r===null||r.trim().length===0){console.warn("[product-row]","No data-api-base on section root, skipping editorial fetch");return}const o=t.querySelectorAll("[data-yqr-row-card]");if(o.length===0)return;const c=[],i=new Map;for(const s of o){const l=s.getAttribute("data-shopify-product-id");if(l===null||l.trim().length===0)continue;const d=Number(l);Number.isNaN(d)||(i.has(l)||(c.push(d),i.set(l,[])),i.get(l).push(s))}if(c.length===0)return;let a;try{a=await Ie(r,c,n)}catch(s){const l=s instanceof Error?s.message:String(s);console.warn("[product-row]","Editorial fetch failed:",l);return}for(const s of a){const l=i.get(s.shopify_id);if(!(l===void 0||l.length===0))for(const d of l)Fe(d,s),Oe(d,s)}}function Fe(t,e){var r,n;const o=t.querySelector("[data-yqr-row-card-mechanism]");if(o===null)return;const c=(r=(n=e.editorial)===null||n===void 0||(n=n.mechanism)===null||n===void 0?void 0:n.trim())!==null&&r!==void 0?r:"";if(c.length!==0){o.replaceChildren();for(const i of c.split(/\n{2,}/)){const a=i.trim();if(a.length===0)continue;const s=document.createElement("p");s.textContent=a,o.appendChild(s)}}}function Oe(t,e){var r;const n=t.querySelector("[data-yqr-row-card-ingredients]");if(n===null)return;const o=(r=e.ingredients)!==null&&r!==void 0?r:[];o.length!==0&&qt(o,n)}var ze="[data-product-row]";function kt(t){t.classList.remove("ypr--skeleton"),t.classList.add("ypr--revealed");const e=t.querySelector(".ypr__real-content");e!==null&&e.removeAttribute("hidden")}function M(t,e,r){if(t.has(e)){const n=t.t(e).trim();if(n.length>0)return n}return r}function He(t){return{why_this_summary_with_markers:M(t,"why_this_summary_with_markers","Why this for you?"),why_this_summary_without_markers:M(t,"why_this_summary_without_markers","Why we recommend this"),why_this_safety_note_heading:M(t,"why_this_safety_note_heading","Safety note"),why_this_you_said_prefix:M(t,"why_this_you_said_prefix","You said"),why_this_when_asked_prefix:M(t,"why_this_when_asked_prefix","when asked")}}function We(t,e,r){const n=t.trim().length>0?t:r,o=e.trim();return o.length===0?n.replaceAll("{focus_area}","").replace(/\s+/g," ").trim():n.replaceAll("{focus_area}",o).replaceAll("{ focus_area }",o)}function Ue(t){const e=t.dataSource==="quiz_foundations"?"stack":"sports",r=e;Mt(n=>{const o=Tt(n.i18n),c=wt(Rt,n.catalog,n.formatPrice,n.i18n),i=Pt({sectionKind:e,maxItems:t.maxItems,showWhenRoutineIs:t.showWhenRoutineIs},n),a=x("[data-ypr-list]",t.root),s=x("[data-ypr-heading]",t.root);if(a===null){console.warn("[product-row]","Missing list host");return}if(!i.render){t.root.classList.add("ypr--hidden"),t.root.setAttribute("aria-hidden","true"),ot(`product-row:${t.sectionId}`,[]),a.replaceChildren();return}if(t.root.classList.remove("ypr--hidden"),t.root.removeAttribute("aria-hidden"),s!==null){var l,d;const h=(l=(d=n.focusArea)===null||d===void 0?void 0:d.name)!==null&&l!==void 0?l:"",b=e==="stack"?o.has("stack_heading_template")?o.t("stack_heading_template"):"To round out your routine":"";s.textContent=We(t.headingTemplate,h,b)}const u=t.root.querySelector("[data-ypr-intro]");if(u!==null){const h=e==="stack"?n.aiSummary.stackIntro:n.aiSummary.sportsIntro;h!==null&&(u.textContent=h)}const m=t.cardDensity==="compact"?"yqr-row-card--compact":"yqr-row-card--comfortable";a.replaceChildren();const p=[];for(const h of i.items){const b=n.catalog.lookup(h.shopify_id);if(b===null){console.warn("[product-row]","No catalog entry for shopify_id",h.shopify_id);continue}const q=ve(h,b,{formatPrice:n.formatPrice,healthMarkerSources:n.result.health_marker_sources,whyThisLabels:He(o),showWhyThis:t.showWhyThis,addToCartSource:r,densityClass:m,learnMoreLabel:o.has("learn_more")?o.t("learn_more"):"Learn more",priceFromLabel:M(o,"price_from_prefix","From"),supplyNoteLabel:M(o,"supply_note","for a 1 month supply")});a.appendChild(q),we(q,b,r,c,M(o,"row_card_cta_label","Configure now"),o.has("sold_out")?o.t("sold_out"):"Sold out"),p.push(h)}if(p.length===0){t.root.classList.add("ypr--hidden"),t.root.setAttribute("aria-hidden","true"),ot(`product-row:${t.sectionId}`,[]);return}ot(`product-row:${t.sectionId}`,p);const w=t.root.hasAttribute("data-yqr-cascade"),v=document.querySelector("[data-yqr-video-hero]")!==null;w&&v?me(t.root,()=>kt(t.root)):kt(t.root)})}function je(t){Be(t),Ne(t),De(t)}function $t(){const t=document.querySelectorAll(ze);if(t.length!==0)for(const e of t)try{const r=Ce(e);r.dataSource==="manual"?je(e):Ue(r)}catch(r){if(r instanceof nt){console.warn(`[product-row] ${r.message}`);continue}throw r}}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",$t):$t()})();
